import { render, staticRenderFns } from "./MassageRecord.vue?vue&type=template&id=06662bb4"
import script from "./MassageRecord.vue?vue&type=script&lang=js"
export * from "./MassageRecord.vue?vue&type=script&lang=js"
import style0 from "./MassageRecord.vue?vue&type=style&index=0&id=06662bb4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06662bb4')) {
      api.createRecord('06662bb4', component.options)
    } else {
      api.reload('06662bb4', component.options)
    }
    module.hot.accept("./MassageRecord.vue?vue&type=template&id=06662bb4", function () {
      api.rerender('06662bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/MassageRecord.vue"
export default component.exports